import React, { Component } from "react"
import Layout from "../components/layout";
import Header from "../components/header";
import faceBook from '../images/footer/facebook-logo.png'
import insta from '../images/footer/insta.png'
import linkedIn from '../images/footer/linkedin.png'
import "../css/sharan-style.css";
import PopupForm from "./popupForm";
import Img from 'gatsby-image'

class Footer  extends Component {

    constructor(props) {
        super(props)
        this.state = {
            time: 90000000
        }
    }

    handlePopupWindow = () => {
        this.setState({ time: Math.random() })
    }

    render(){
        return(
            <div>
                <PopupForm time={this.state.time} />
                <footer class="Footer-custom-styling"> 
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="footer-inner">
                                    <div class="footer-logo">
                                        <a href="/">
                                            <img 
                                                src="https://media.publit.io/file/TheWorldgrad/FooterCommon/footer-logo_k6skj4.svg" 
                                                alt="" 
                                                class="img-fluid" 
                                            />
                                        </a>
                                    </div>
                                    <div className="row mb-0">
                                        <div className="col-md-6 footer-link mt-3" >
                                            <h3 className="mb-0"> Head Office </h3>
                                            <p className="my-0">
                                                91Springboard, Godrej Business Park, Gate 2 Plant 6, LBS Road, Vikhroli West, Mumbai - 400079
                                            </p>
                                        </div>
                                        <div className="col-md-6 footer-link mt-3" >
                                            <h3 className="mb-0"> Delhi Office </h3>
                                            <p className="my-0">
                                                91Springboard, 3rd Floor, Chandra Bhavan, 68-68, Nehru Place, New Delhi - 110019
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 my-0">
                                            <p className="my-0" > Phone: 080-45681763 </p>
                                        </div>
                                        <div className="col-12 my-0">
                                            <p className="my-0">
                                                <a href="mailto:enquiries@theworldgrad.com">Student Admissions: enquiries@theworldgrad.com</a>
                                            </p>
                                        </div>
                                        <div className="col-12 my-0">
                                            <p className="my-0">
                                                <a href="mailto:partnerships@theworldgrad.com">Partnership Queries: partnerships@theworldgrad.com  </a>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    {/* <p>
                                        Phone: 080-468-08329 <br/>
                                        <a href="mailto:enquiries@theworldgrad.com">Student Admissions: enquiries@theworldgrad.com</a><br></br>
                                        <a href="mailto:partnerships@theworldgrad.com">Partnership Queries: partnerships@theworldgrad.com  </a>
                                    </p> */}
                                    <div class="socail-media">
                                        <ul>
                                            {/* <li><a href="#"><img src="images/facebook-icon.svg" alt="" /></a></li>
                                            <li><a href="#"><img src="images/twitter-icon.svg" alt="" /></a></li>
                                            <li><a href="#"><img src="images/instagram-icon.svg" alt="" /></a></li>
                                            <li><a href="#"><img src="images/linkdin-icon.svg" alt="" /></a></li> */}
                                            
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <div class="footer-link">
                                    <h3>Explore</h3>
                                    <div class="media">
                                        <ul>
                                            <li><a href="/about-us/">About Us</a></li>
                                            <li>
                                                <a href="#">Institutions</a>
                                                <div className="row">
                                                    <div className="col-5">
                                                        <ul className="footer-bullets">
                                                            <li>
                                                                <a href="/universities/usa"> USA </a>
                                                            </li>
                                                            <li>
                                                                <a href="/universities/australia"> Australia </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-2">
                                                        <ul className="footer-bullets">
                                                            <li> | </li>
                                                            <li> | </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-5">
                                                        <ul className="footer-bullets">
                                                            <li>
                                                                <a href="/universities/united-kingdom"> UK </a>
                                                            </li>
                                                            <li>
                                                                <a href="/universities/uae"> UAE </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <a href="#">Countries</a>
                                                <div className="row">
                                                    <div className="col-5">
                                                        <ul className="footer-bullets">
                                                            <li>
                                                                <a href="/countries/usa"> USA </a>
                                                            </li>
                                                            <li>
                                                                <a href="/countries/australia"> Australia </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-2">
                                                        <ul className="footer-bullets">
                                                            <li> | </li>
                                                            <li> | </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-5">
                                                        <ul className="footer-bullets">
                                                            <li>
                                                                <a href="/countries/united-kingdom"> UK </a>
                                                            </li>
                                                            <li>
                                                                <a href="/countries/uae"> UAE </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>                                                
                                            </li>
                                            <li><a href="/blogs/">Study Resources</a></li>
                                            <li><a href="/faq/">FAQs</a></li> 
                                            {/* <li><a href="/program-listing/">Programs</a></li> */}
                                        </ul>
                                        <ul>
                                        
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-sm-6">
                                <div class="footer-link">
                                    <h3>Information</h3> 
                                    <ul>
                                        {/* <li><a href="#">My courses</a></li> */}
                                        <li><a href="/privacypolicy/">Privacy Policy</a></li>
                                        {/* <li><a href="#">Terms & Conditions</a></li> */}
                                        {/* <li><a href="#">How to Apply</a></li> */}
                                        <li><a onClick={() => this.handlePopupWindow()}>Enquiry</a></li>
                                        <li><a href="https://studentportal.theworldgrad.com" target="_blank">Applications</a></li>
                                        <li><a href="/terms-and-condtions/">Terms and Conditions</a></li>
                                    </ul> 
                                </div>

                                <div class="footer-link social-footer">
                                    <h3>Social</h3> 
                                    <ul className='d-flex'>
                                        <li>
                                            <a href="https://www.facebook.com/The-WorldGrad-104434275220410" target="_blank">
                                            <img src={faceBook} alt="facebook logo"/></a>
                                        </li>
                                        <li>
                                            <a href="https://instagram.com/theworldgrad?utm_medium=copy_link" target="_blank">
                                            <img src={insta} alt="insta logo"/></a>
                                        </li>  
                                        <li>
                                            <a href="https://www.linkedin.com/company/the-worldgrad" target="_blank">
                                            <img src={linkedIn} alt="linkedin logo"/></a>
                                        </li>
                                        
                                        {/* {
                                            this.props.iconsArr.edges.map(icon => {
                                                return (
                                                    <li key={icon.node.id}>
                                                        <a href="#">
                                                            <Img fixed={icon.node.childImageSharp.fixed} />
                                                        </a>
                                                    </li>
                                                )
                                            })
                                        } */}
                                    </ul> 
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="copyright">
                                    <p>©LINC Education 2021. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div> 
                </footer>
            </div>
        )

    }
}
export default Footer;
